import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { useField } from 'react-final-form';
import { FieldErrorText } from '@/components/functional/Form/FieldErrorText/FieldErrorText';
import { FIELD_KEY_NAME_FILE, FIELD_KEY_NAME_UNIQUE_ID, } from '@/components/modules/form/FileUploadField/const';
import { useFileUploadField } from '@/components/modules/form/FileUploadField/useFileUploadField';
import { UploadFileButton } from '@/components/ui/Form/UploadFile/UploadFileButton';
import { UploadFileLink } from '@/components/ui/Form/UploadFile/UploadFileLink';
import { createRandomStringId } from '@/utils/libs/uuid/createId';
export const MultiFileUploadField = (props) => {
    const { className = '', fieldIndex, fieldKeyNameOfId, fieldKeyNameOfName, fieldKeyNameOfNewId, fieldKeyNameOfPath, fieldName, onClickDelete: propsOnClickDelete, onClickLink, onStartUploadingCallback, onStopUploadingCallback, render, uploadFile, validateOfFile, validateOfNewId, } = props;
    const fieldNameOfFile = `${fieldName}.${FIELD_KEY_NAME_FILE}`;
    const fieldNameOfUniqueId = `${fieldName}.${FIELD_KEY_NAME_UNIQUE_ID}`;
    const fieldNameOfId = `${fieldName}.${fieldKeyNameOfId}`;
    const fieldNameOfNewId = `${fieldName}.${fieldKeyNameOfNewId}`;
    // Field Value
    const { input: { value: fieldValue }, } = useField(fieldName);
    // Field id
    const { input: { value: idValue }, } = useField(fieldNameOfId, {
        validateFields: [],
    });
    // Field file
    const { input: { onBlur: onBlurFile, value: fileValue }, meta: { invalid }, } = useField(fieldNameOfFile, {
        // subscription: { invalid: true, value: true },
        validate: validateOfFile,
        validateFields: [],
    });
    // Field uniqueId
    const { input: { onChange: onChangeUniqId, value: uniqueIdValue }, } = useField(fieldNameOfUniqueId);
    /**
     * ファイル選択時にユニークID付与
     */
    const onChangeFileCallback = useCallback(() => {
        // touched 更新
        onBlurFile();
        // ユニークID が既にある場合アップロードしない
        if (uniqueIdValue) {
            return false;
        }
        // Field追加時にユニークID付与
        const uniqueId = createRandomStringId();
        onChangeUniqId(uniqueId);
        return true;
    }, [onBlurFile, onChangeUniqId, uniqueIdValue]);
    /**
     * 削除ボタンクリック時のイベント
     */
    const onClickDelete = useCallback(() => {
        propsOnClickDelete(fieldIndex);
    }, [fieldIndex, propsOnClickDelete]);
    // ファイルアップロード処理
    const { inputFile, loading, nameValue, newIdValue, pathValue } = useFileUploadField({
        fieldKeyNameOfName,
        fieldKeyNameOfNewId,
        fieldKeyNameOfPath,
        fieldName,
        fileValue,
        invalid,
        onChangeFileCallback,
        onStartUploadingCallback,
        onStopUploadingCallback,
        uploadFile,
        validateOfNewId,
    });
    return (_jsxs(_Fragment, { children: [(() => {
                if (render) {
                    return render({
                        fieldValue,
                        inputFile,
                        invalid,
                        loading,
                        onClickDelete,
                    });
                }
                if (pathValue) {
                    return (_jsx(UploadFileLink, { className: className, fileLink: pathValue, fileName: (inputFile === null || inputFile === void 0 ? void 0 : inputFile.name) || nameValue, hasUploadError: !!(inputFile === null || inputFile === void 0 ? void 0 : inputFile.name) && invalid, isDeletable: true, isUploading: loading, onClickDelete: onClickDelete }));
                }
                return (_jsx(UploadFileButton, { className: className, fileName: (inputFile === null || inputFile === void 0 ? void 0 : inputFile.name) || nameValue, hasUploadError: !!(inputFile === null || inputFile === void 0 ? void 0 : inputFile.name) && invalid, id: newIdValue || idValue, isDeletable: true, isUploading: loading, onClickDelete: onClickDelete, onClickLink: onClickLink }));
            })(), _jsx(FieldErrorText, { name: fieldNameOfFile }), _jsx(FieldErrorText, { name: fieldNameOfNewId })] }));
};
